import { RevenueOpportunityStatusPresetsTableActions } from "routes/revenue_opportunity_status_presets/RevenueOpportunityStatusPresetsTableActions";

export const getRevenueOpportunityStatusPresetsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 250,
    },
    {
      header: "Revenue Opportunity Statuses",
      id: "Revenue Opportunity Statuses",
      accessorKey: "info.revenue_opportunity_statuses",
      enableSorting: false,
      cell: ({ row }) => {
        const value = row.original?.info?.revenue_opportunity_statuses;
        return value && value.length > 0
          ? value.map(({ name }) => name).join(", ")
          : "--";
      },
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <RevenueOpportunityStatusPresetsTableActions original={row.original} />
      ),
    },
  ];
};

export const getRevenueOpportunityStatusPresetsTableFilters = () => {
  return [];
};
